export const CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR = 'CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR';
export type CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR = typeof CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR;

export interface ChangePageIdCampaignPlaceEditor {
    type: CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR;
    editorId: string;
    pageId: string;
}

export function changePageIdCampaignPlaceEditorAction(
    editorId: string,
    pageId: string
): ChangePageIdCampaignPlaceEditor {
    return {
        type: CHANGE_PAGE_ID_CAMPAIGN_PLACE_EDITOR,
        editorId,
        pageId
    };
}
